export type FormationPollTerminalApiErrorKind = 'auth' | 'status_api';

function hasApiErrorBody(data: unknown): data is { error: string } {
  return typeof data === 'object'
    && data !== null
    && typeof (data as { error?: unknown }).error === 'string';
}

/**
 * Poll errors that must stop retrying and show failed alert (not pending).
 * 401 — session invalid; 500 with { error } — formation-status API failure.
 */
export function isFormationPollTerminalApiError(
  status: number | undefined,
  responseData: unknown,
): FormationPollTerminalApiErrorKind | null {
  if (status === 401) {
    return 'auth';
  }
  if (status === 500 && hasApiErrorBody(responseData)) {
    return 'status_api';
  }
  return null;
}
